<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div v-show="company_id">
          <div class="mt-3">
            <Checkbox v-model="first_active" :binary="true" />Nếu phiếu tồn tại rủi ro cao nhất và biện pháp kiểm soát “Lặp lại”, cần đánh giá lại cách lần đánh giá cuối của phiếu
          </div>
          <div class="mt-3" v-show="first_active">
            <div class="p-inputgroup" style="margin-left: 2.2rem; width: 300px">
              <InputText
                v-model="first_month"
                type="Number"
                class="text-box input-text-box"
                placeholder="Nhập"
              />
              <span class="p-inputgroup-addon">
                tháng
              </span>
            </div>
          </div>
          <div class="mt-3">
            <Checkbox v-model="second_active" :binary="true" />Nếu phiếu tồn tại rủi ro cao nhì và biện pháp kiểm soát “Lặp lại”, cần đánh giá lại cách lần đánh giá cuối của phiếu
          </div>
          <div class="mt-3" v-show="second_active">
            <div class="p-inputgroup" style="margin-left: 2.2rem; width: 300px">
              <InputText
                v-model="second_month"
                type="Number"
                class="text-box input-text-box"
                placeholder="Nhập"
              />
              <span class="p-inputgroup-addon">
                tháng
              </span>
            </div>
          </div>
          <div class="mt-3">
            <Checkbox v-model="control_measures" :binary="true" />Nếu phiếu có biện pháp kiểm soát nằm trong dự án, cần đánh giá lại ngay khi dự án “Hoàn thành”
          </div>
          <div class="mt-3">
            <Checkbox v-model="prioritize" :binary="true" />Luôn ưu tiên lần đánh giá lại ngay khi dự án “Hoàn thành”
          </div>
          <div class="mt-3" v-if="updated_at && updated_by && username">
            <span class="txt-last-update">Cập nhật lần cuối lúc: {{ updated_at }} bởi {{ updated_by }} - {{ username }}</span>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            v-if="$store.getters.controllers?.list_setting && $store.getters.controllers?.list_setting.includes('edit')"
            label="Lưu thay đổi"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    company_id: String
  },
  data() {
    return {
      filters: {},
      first_active: false,
      first_month: null,
      second_active: false,
      second_month: null,
      control_measures: false,
      prioritize: false,
      username: null,
      updated_at: null,
      update_by: null,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      time_zone_local : moment.tz.guess(true),
    };
  },
  async mounted() {
    if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
      await this.getListCompany();
    }
  },
  watch: {
    "company"() {
      this.$emit('company', this.company?.id);
    },
    "$props.model"() {
      if (this.model !== undefined && Object.keys(this.model).length > 0) {
        this.first_active = this.model.first_active;
        this.first_month = this.model.first_month;
        this.second_active = this.model.second_active;
        this.second_month = this.model.second_month;
        this.control_measures = this.model.control_measures;
        this.prioritize = this.model.prioritize;
        this.username = this.model.username;
        this.updated_at = this.model.updated_at ? moment.tz(this.model.updated_at, this.time_zone_local).format("DD/MM/yyyy") : null;
        this.updated_by = this.model.updated_by;
      }
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        first_active: this.first_active,
        first_month: this.first_month,
        second_active: this.second_active,
        second_month: this.second_month,
        control_measures: this.control_measures,
        prioritize: this.prioritize,
        company: this.company
      };
      console.log("saveData", params);
      this.$emit("save", params);
      // }
    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.txt-last-update {
  color: #666666;
  font-size: calc(16px*0.8);
}
</style>
